var render = function render(){var _vm=this,_c=_vm._self._c;return (this.displayStats)?_c('div',[_c('MedalTable',{attrs:{"stats":_vm.stats}}),_c('EternalTable',{attrs:{"stats":_vm.stats}}),_c('MiscStats',{attrs:{"stats":_vm.stats}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }